import(/* webpackMode: "eager" */ "/app/src/app/(app)/page.tsx");
